import axios from 'axios'
import React, { useEffect, useState } from 'react'

import { getUrlParam } from 'core-components/helpers/url'
import { ProcessingText } from 'core-components/library/loader'
import { NotificationController } from 'core-components/library/popup'
import { omnicomProxy } from 'omnicom/utils/omnicomProxy'
import { Common } from 'src/core/imgStore'
import Logger from 'src/core/utils/Logger'

import { BG_URL } from './config'

import styles from './CallMeBack.module.scss'

export const CallMeBack = () => {
  const [loading, setLoading] = useState<boolean>(false)

  useEffect(() => {
    setLoading(true)
    axios
      .post(
        omnicomProxy('/api/v0/emailsLink/callMeBack'),
        {
          pdlUID: getUrlParam('PDLUID') || null,
          pdlId: +getUrlParam('PDLEntryId') || null,
          campaignId: +getUrlParam('CampaignId') || null,
        },
        { headers: { 'Content-Type': 'application/json; charset=UTF-8' } }
      )
      .then(({ data }) => {
        const responseInfo = data.data
        if (responseInfo.success) {
          NotificationController.showSuccess({ message: responseInfo.message })
        }
      })
      .catch((err) => {
        const responseInfo = err.response.data.data
        NotificationController.showError({ message: responseInfo.message })
        Logger.error(responseInfo.message)
      })
      .finally(() => {
        setLoading(false)
      })
  }, [])

  return (
    <div
      className={styles.root}
      style={{
        backgroundImage: BG_URL,
      }}
    >
      <img className={styles.logo} src={Common['hp-logo']} alt="HP" />
      <div className={styles.message}>
        {loading ? (
          <ProcessingText text={'Wait'} />
        ) : (
          <>
            Thank you for your interest in HP.
            <br />
            We will get in touch with you shortly.
          </>
        )}
      </div>
    </div>
  )
}
